import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'vex-exercise-tracker-detail',
  templateUrl: './exercise-tracker-detail.component.html',
  styleUrls: ['./exercise-tracker-detail.component.scss']
})
export class ExerciseTrackerDetailComponent implements OnInit {
  @Input() exercise;
  environment = environment.baseURL;

  constructor(public guiService: GuiService, public translate: TranslateService, private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.exercise = data.exercise;
  }

  ngOnInit(): void {
  }

  closeModal(){
    this.dialogRef.close();
  }

  convertToMMSS(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes.toString();
    const formattedSeconds = remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds.toString();

    return `${formattedMinutes}:${formattedSeconds}`;
  }

}
